export default "__VITE_ASSET__z4qPSDfm__"